import { render, staticRenderFns } from "./delMessage.vue?vue&type=template&id=bcb1f3c8&scoped=true&"
import script from "./delMessage.vue?vue&type=script&lang=js&"
export * from "./delMessage.vue?vue&type=script&lang=js&"
import style0 from "./delMessage.vue?vue&type=style&index=0&id=bcb1f3c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb1f3c8",
  null
  
)

export default component.exports